import { render, staticRenderFns } from "./School.vue?vue&type=template&id=078bc15a&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"
import style0 from "./School.vue?vue&type=style&index=0&id=078bc15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078bc15a",
  null
  
)

export default component.exports